import { api } from '@/shared/redux/api/_generated/api/ident-public-api.generated';

export const identPublicApi = api.enhanceEndpoints({});

export const {
  useCreateTenantMutation,
  useConfirmUserMutation,
  useForgotPasswordMutation,
  useReadIdentityProviderByEmailMutation,
} = identPublicApi;
